/**
 * The ONLY host composition permitted in this codebase. Everything else comes
 * from bootstrap.
 *
 * `location.protocol` (never a literal `https://`) mirrors the page scheme and
 * keeps plain-HTTP local dev working. `location.host` (never
 * `location.hostname`) includes the port, which is what the routing layer
 * matches. `API_CONTEXT_ROOT` is a code constant, not an env variable — it never
 * varies by environment, so it is not configuration.
 *
 * Exported as functions, not module-level constants, so a test can re-stub
 * `location` per test — a constant evaluated at import time cannot be.
 */
export const API_CONTEXT_ROOT = '/dink-api';

export function apiOrigin(): string {
  return `${location.protocol}//api.${location.host}`;
}

export function apiBase(): string {
  return `${apiOrigin()}${API_CONTEXT_ROOT}`;
}
